export default "__VITE_ASSET__Dh_FioGV__"